const WEBSITE_CRM_PROCEED_EXACT = new Set([
  'yes',
  'yess',
  'proceed',
  'yes and proceed',
  'yes proceed',
  'yes, proceed',
  'yes, and proceed',
])

/** @param {string} trimmed */
function normalizeProceedPrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isWebsiteCrmProceedPrompt(trimmed) {
  const normalized = normalizeProceedPrompt(trimmed)
  if (WEBSITE_CRM_PROCEED_EXACT.has(normalized)) return true
  return normalized.startsWith('yes') && normalized.includes('proceed')
}

/**
 * @param {unknown[]} priorMessages
 * @returns {boolean}
 */
export function threadAwaitingWebsiteCrmDeployProceed(priorMessages) {
  if (!Array.isArray(priorMessages) || priorMessages.length === 0) return false

  for (let i = priorMessages.length - 1; i >= 0; i--) {
    const message = priorMessages[i]
    if (!message || typeof message !== 'object') continue

    const role = /** @type {{ role?: string }} */ (message).role
    if (role !== 'assistant') continue

    const assistant = /** @type {{
      websiteCrmAwaitingDeployProceed?: boolean
      websiteCrmAwaitingConnect?: boolean
      gcpHostingDeployCompleted?: boolean
    }} */ (message)

    if (assistant.gcpHostingDeployCompleted) return false
    if (assistant.websiteCrmAwaitingDeployProceed || assistant.websiteCrmAwaitingConnect) {
      return true
    }
    return false
  }

  return false
}

/** @deprecated Use {@link threadAwaitingWebsiteCrmDeployProceed}. */
export function threadAwaitingWebsiteCrmConnect(priorMessages) {
  return threadAwaitingWebsiteCrmDeployProceed(priorMessages)
}
